module.exports = __webpack_public_path__ + "static/img/banli.1a25d12f.png";